module.exports = __webpack_public_path__ + "img/icon_acount_logo_n.810f761b.png";